import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {useLocation } from "react-router-dom";

const FitOnboardingDashboard = () => {
    const [data, setData] = useState([]);
    const [expandedCard, setExpandedCard] = useState(null);
    const[access, setAccess] = useState(-1)
    const location = useLocation();
    const navigate = useNavigate();
    const [pid] = useState(location?.state?.pid )



    

    // Authentication and access verification
    useEffect(() => {
        if (!pid) {
            navigate('/');
        } else {
            const body = { "username": pid, "scope": "participant" };
            let connectionString = "https://app.digitalwellnessnurse.com";
    
            fetch(`${connectionString}/api/portal/verify`, {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                credentials: "include",
                body: JSON.stringify(body),
            })
            .then((response) => {
                setAccess(response.status);
                return response.json();
            })
            .then((json) => {
                if (json.access !== 200) {
                    navigate('/');
                } 
            })
            .catch((error) => {
                console.error("Error verifying access:", error);
            });
        }
    }, [pid, navigate]);


    useEffect(() => {
        if (access !== 200) return; // Ensure we fetch only when authenticated

        const fetchData = async () => {
            const url = "https://app.digitalwellnessnurse.com/api/portal/fit/get-prescreener";
            try {
                const response = await fetch(url, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" }
                });

                if (!response.ok) {
                    throw new Error(`Failed to fetch: ${response.status}`);
                }

                const result = await response.json();
                setData(result);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, [access]); // Runs when access updates


    // Start onboarding process
    const startVerification = (firstName, lastName, phoneNumber) => {
        var preScreening ={ 
            firstName:firstName,
            lastName:lastName,
            phoneNumber:phoneNumber
        }
        navigate('/FitVerification', { state: { pid:pid , preScreening: preScreening} });
        // Add your onboarding logic here
    };

    // Toggle card expansion
    const toggleCardDetails = (index) => {
        setExpandedCard(expandedCard === index ? null : index);
    };

    return (
        <div style={{ padding: '20px' }}>
            <h1>Onboard a Family</h1>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                {data.map((person, index) => (
                    <div
                        key={index}
                        style={{
                            border: '1px solid #ccc',
                            padding: '10px',
                            backgroundColor: 'white', // Green for true, red for false
                        }}
                    >
                        <h2 style={{ color: person.contacted ? 'green' : 'red'}}>
                            {person.firstName} {person.lastName}
                        </h2>
                        {!person.contacted && (
                            <button
                                style={{
                                    marginTop: '10px',
                                    padding: '5px 10px',
                                    backgroundColor: '#007bff',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                }}
                                onClick={() =>
                                    startVerification(person.firstName, person.lastName, person.phoneNumber)
                                }
                            >
                                Onboard
                            </button>
                        )}
                        <button
                            style={{
                                marginTop: '10px',
                                marginLeft: '10px',
                                padding: '5px 10px',
                                backgroundColor: '#ccc',
                                color: '#000',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                            }}
                            onClick={() => toggleCardDetails(index)}
                        >
                            {expandedCard === index ? 'Hide Details' : 'View Details'}
                        </button>
                        {expandedCard === index && (
                            <div style={{ marginTop: '10px', padding: '10px', border: '1px solid #ddd' }}>
                                <p><strong>Phone Number:</strong> {person.phoneNumber}</p>
                                <p><strong>Date:</strong> {new Date(person.date).toLocaleDateString()}</p>
                                <p><strong>Contacted:</strong> {person.contacted ? 'Yes' : 'No'}</p>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FitOnboardingDashboard;
